<script>
  import DepartmentCard from "@helpers/DepartmentCard.svelte";

  export let data;
  export let rankings;

  const addRemoveItem = function (item) {
    if (rankings.map((d) => d.Department).includes(item.Department)) {
      rankings = rankings.filter((d) => d.Department !== item.Department);
    } else {
      if (rankings.length === 4) return;
      rankings.push(item);
    }
    rankings = rankings;
  };
</script>

<DepartmentCard
  hasBudget={false}
  wrapperClass="{rankings.map((d) => d.Department).includes(data.Department)
    ? 'selected'
    : 'unselected'} {(!rankings
    .map((d) => d.Department)
    .includes(data.Department) &&
    rankings.length === 4 &&
    'unselectable') ||
    ''}
  "
  item={data}
  onClick={() => {
    addRemoveItem(data);
  }}
/>
